function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "delivery_svg__a",
  d: "M0 126.539h166.184V.236H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "delivery_svg__c",
  d: "M.389.002h25.727v25.727H.389z"
}), /*#__PURE__*/React.createElement("path", {
  id: "delivery_svg__e",
  d: "M.247.002h25.727v25.727H.247z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.071 26.587)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE32",
  d: "M63.52 54.515c0 4.176-3.384 7.56-7.56 7.56s-7.56-3.384-7.56-7.56 3.384-7.56 7.56-7.56 7.56 3.384 7.56 7.56"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8FBCF",
  d: "M3.832 91.522h19.896v-28.65l20.692-8.755 21.488 7.959v29.245h97.889v26.464H3.832z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "delivery_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#delivery_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.299 75.605h7.958v-7.958h-7.958zm0 14.325h7.958v-7.958h-7.958z",
  mask: "url(#delivery_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2F4F5",
  d: "M3.832 126.539h160.76V109.03H3.832z",
  mask: "url(#delivery_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE32",
  d: "M97.315 104.29h66.963V35.017H97.315zm0 .899v-54.71H73.528L62.23 72.481l-18.704 8.93v23.778z",
  mask: "url(#delivery_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#406367",
  d: "M40.348 105.561h125.836V95.393H40.348z",
  mask: "url(#delivery_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2B982",
  d: "M68.77 72.481h23.788V54.047H77.691z",
  mask: "url(#delivery_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8FBCF",
  d: "M84.233 81.402h8.92v-3.568h-8.92zm3.084-27.355l-6.652 18.434H68.176l8.92-18.434z",
  mask: "url(#delivery_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M49.132 78.733l-5.606 10.304V81.41z",
  mask: "url(#delivery_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8FBCF",
  d: "M96.911 35.017l67.007 60.375H96.911z",
  mask: "url(#delivery_svg__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(54.821 117.906)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "delivery_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#delivery_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#002F34",
  d: "M7.856 1.193c-6.448 2.98-9.257 10.624-6.276 17.07 2.981 6.448 10.624 9.257 17.07 6.276 6.448-2.981 9.257-10.624 6.277-17.07-2.982-6.447-10.624-9.257-17.071-6.277",
  mask: "url(#delivery_svg__d)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M66.009 126.305a4.921 4.921 0 11-2.401 6.532 4.926 4.926 0 012.401-6.532"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(134.406 117.906)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "delivery_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#delivery_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#002F34",
  d: "M7.713 1.193c-6.447 2.98-9.257 10.624-6.276 17.07 2.981 6.448 10.624 9.257 17.07 6.276 6.448-2.981 9.257-10.624 6.277-17.07-2.98-6.447-10.623-9.257-17.07-6.277h-.001",
  mask: "url(#delivery_svg__f)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M145.451 126.305a4.92 4.92 0 114.133 8.933 4.92 4.92 0 01-4.134-8.933"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CEDDFF",
  d: "M92.756 59.217a5.97 5.97 0 00-5.85-7.164c-.944 0-1.835.227-2.63.618-1.855-3.22-5.324-5.392-9.307-5.392-5.299 0-9.691 3.84-10.573 8.886a3.944 3.944 0 00-.967-.132 3.98 3.98 0 00-3.899 3.184h33.226z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3A77FF",
  d: "M139.693 40.912c.09-.44.137-1.34.137-1.807a6.824 6.824 0 00-6.823-6.824c-1.081 0-2.1.258-3.008.706-2.121-3.68-6.086-6.164-10.64-6.164-6.057 0-11.078 4.39-12.086 10.158a4.532 4.532 0 00-1.106-.15c-2.2 0-4.035 2.005-4.458 4.081h37.984z"
}));

const SvgDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 180 180"
}, props), _ref, _ref2);

export default SvgDelivery;